export default __webpack_public_path__ + "static/media/SD-gallery-05.cde94367.png";